export enum RateRuleType {
  ADVANCED_PURCHASE = 'advancePurchase',
  ADVANCED_BOOKING = 'advanceBooking'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/rate-rule.type.model.ts